export default __webpack_public_path__ + "static/media/information--bicycle-lane--g1.504421c1.png";